// import React, { useState, useEffect, useRef } from 'react';
// import { Grid, Typography, Box } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import BusinessIcon from '@mui/icons-material/Business';
// import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
// import PersonIcon from '@mui/icons-material/Person';
// import WarningIcon from '@mui/icons-material/Warning';
// import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
// import {
//   listCompanies,
//   listInsCompanies as getInsuranceCompanies,
//   listAgents as getAgents,
//   listRiskItems as getRiskItems,
//   listBankers as getBankers,
// } from '../api';

// const CompanyCards = () => {
//   const navigate = useNavigate();
//   const [companyStats, setCompanyStats] = useState({
//     total_companies: 0,
//     total_insurance_companies: 0,
//     total_agents: 0,
//     total_risk_items: 0,
//     total_financiers: 0,
//   });

//   useEffect(() => {
//     const fetchCompanyStats = async () => {
//       try {
//         const [companyDetails, insuranceCompanies, agents, riskItems, bankers] = await Promise.all([
//           listCompanies(),
//           getInsuranceCompanies(),
//           getAgents(),
//           getRiskItems(),
//           getBankers(),
//         ]);

//         setCompanyStats({
//           total_companies: companyDetails.length,
//           total_insurance_companies: insuranceCompanies.length,
//           total_agents: agents.length,
//           total_risk_items: riskItems.length,
//           total_financiers: bankers.length,
//         });
//       } catch (error) {
//         console.error('Failed to fetch company stats:', error.message);
//         // Fallback to 0 if API fails
//         setCompanyStats({
//           total_companies: 0,
//           total_insurance_companies: 0,
//           total_agents: 0,
//           total_risk_items: 0,
//           total_financiers: 0,
//         });
//       }
//     };

//     fetchCompanyStats(); // Initial fetch
//     const interval = setInterval(fetchCompanyStats, 30000); // Poll every 30 seconds
//     return () => clearInterval(interval); // Cleanup on unmount
//   }, []);

//   const cardData = [
//     {
//       title: 'Total Companies',
//       value: companyStats.total_companies,
//       icon: <BusinessIcon fontSize="large" sx={{ color: '#ffffff' }} />,
//       tab: 0, // Maps to "Company" tab
//     },
//     {
//       title: 'Insurance Companies',
//       value: companyStats.total_insurance_companies,
//       icon: <AccountBalanceIcon fontSize="large" sx={{ color: '#ffffff' }} />,
//       tab: 1, // Maps to "Insurance" tab
//     },
//     {
//       title: 'Agents',
//       value: companyStats.total_agents,
//       icon: <PersonIcon fontSize="large" sx={{ color: '#ffffff' }} />,
//       tab: 2, // Maps to "Agent" tab
//     },
//     {
//       title: 'Risk Items',
//       value: companyStats.total_risk_items,
//       icon: <WarningIcon fontSize="large" sx={{ color: '#ffffff' }} />,
//       tab: 3, // Maps to "RiskItems" tab
//     },
//     {
//       title: 'Financiers',
//       value: companyStats.total_financiers,
//       icon: <MonetizationOnIcon fontSize="large" sx={{ color: '#ffffff' }} />,
//       tab: 4, // Maps to "Banker" tab
//     },
//   ];

//   return (
//     <>
//       {cardData.length > 0 ? (
//         cardData.map((item, index) => (
//           <Grid item xs={12} sm={6} md={4} lg={2.4} key={index}>
//             <CardWithFlip item={item} navigateTo={() => navigate(`/data?tab=${item.tab}`)} />
//           </Grid>
//         ))
//       ) : (
//         <Typography sx={{ color: '#ffffff', textAlign: 'center', width: '100%' }}>
//           Loading data or no data available
//         </Typography>
//       )}
//     </>
//   );
// };

// const CardWithFlip = ({ item, navigateTo }) => {
//   const [isFlipped, setIsFlipped] = useState(false);
//   const debounceRef = useRef(null);

//   const handleMouseEnter = () => {
//     if (debounceRef.current) clearTimeout(debounceRef.current);
//     debounceRef.current = setTimeout(() => {
//       setIsFlipped(true);
//     }, 100);
//   };

//   const handleMouseLeave = () => {
//     if (debounceRef.current) clearTimeout(debounceRef.current);
//     debounceRef.current = setTimeout(() => {
//       setIsFlipped(false);
//     }, 100);
//   };

//   return (
//     <Box
//       onMouseEnter={handleMouseEnter}
//       onMouseLeave={handleMouseLeave}
//       onClick={navigateTo}
//       sx={{
//         '--sz': 'min(50vh, clamp(100px, 20vw, 280px))',
//         width: 'var(--sz)',
//         height: 'calc(0.35 * var(--sz))', // Half-height rectangular shape
//         maxWidth: 'calc(80vw - 15px)',
//         perspective: '1200px',
//         cursor: 'pointer',
//         fontFamily: '"Mona Sans", sans-serif',
//         position: 'relative',
//         borderRadius: '20px',
//       }}
//     >
//       <Box
//         className="card-inner"
//         sx={{
//           width: '100%',
//           height: '100%',
//           position: 'relative',
//           transformStyle: 'preserve-3d',
//           transition: 'transform 0.6s ease-in-out',
//           transitionDelay: '0.05s',
//           transform: isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)',
//         }}
//       >
//         {/* Front Side */}
//         <Box
//           className="card-front"
//           sx={{
//             position: 'absolute',
//             width: '100%',
//             height: '100%',
//             backfaceVisibility: 'hidden',
//             borderRadius: '20px',
//             background: 'linear-gradient(135deg, #000000 0%, #ffffff 100%)',
//             display: 'flex',
//             alignItems: 'center',
//             padding: '8px 16px',
//             gap: '10px',
//             border: '1px solid #ffffff33',
//             backgroundImage: `
//               linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),
//               linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px)
//             `,
//             backgroundSize: '20px 20px',
//           }}
//         >
//           <Box>{item.icon}</Box>
//           <Box>
//             <Typography
//               variant="h6"
//               sx={{
//                 fontSize: 'calc(3 * var(--fz, 0.038 * var(--sz)))',
//                 fontWeight: 800,
//                 lineHeight: '116%',
//                 color: '#ffffff',
//                 animation: 'textSlide 3s infinite ease-in-out',
//                 '@keyframes textSlide': {
//                   '0%': { transform: 'translateY(0)' },
//                   '50%': { transform: 'translateY(-3px)' },
//                   '100%': { transform: 'translateY(0)' },
//                 },
//               }}
//             >
//               {item.value}
//             </Typography>
//             <Typography
//               variant="body2"
//               sx={{
//                 fontSize: 'calc(1.1 * var(--fz, 0.038 * var(--sz)))',
//                 fontWeight: 600,
//                 lineHeight: '142%',
//                 color: '#ffffffcc',
//                 animation: 'textSlide 3s infinite ease-in-out',
//                 animationDelay: '0.2s',
//                 '@keyframes textSlide': {
//                   '0%': { transform: 'translateY(0)' },
//                   '50%': { transform: 'translateY(-3px)' },
//                   '100%': { transform: 'translateY(0)' },
//                 },
//               }}
//             >
//               {item.title}
//             </Typography>
//           </Box>
//         </Box>
//         {/* Back Side */}
//         <Box
//           className="card-back"
//           sx={{
//             position: 'absolute',
//             width: '100%',
//             height: '100%',
//             backfaceVisibility: 'hidden',
//             borderRadius: '20px',
//             background: 'linear-gradient(135deg, #ffffff 0%, #000000 100%)',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             transform: 'rotateY(180deg)',
//             border: '1px solid #ffffff33',
//             backgroundImage: `
//               linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),
//               linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px)
//             `,
//             backgroundSize: '20px 20px',
//           }}
//         >
//           <Typography
//             variant="body1"
//             sx={{
//               color: '#ffffff',
//               fontWeight: 600,
//               textAlign: 'center',
//               animation: 'textSlide 3s infinite ease-in-out',
//               '@keyframes textSlide': {
//                 '0%': { transform: 'translateY(0)' },
//                 '50%': { transform: 'translateY(-3px)' },
//                 '100%': { transform: 'translateY(0)' },
//               },
//             }}
//           >
//             View Details
//           </Typography>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default CompanyCards;

// const globalStyles = `
//   @import url("https://fonts.cdnfonts.com/css/mona-sans");
// `;
// const styleSheet = document.createElement('style');
// styleSheet.type = 'text/css';
// styleSheet.innerText = globalStyles;
// document.head.appendChild(styleSheet);

import React, { useState, useEffect, useRef } from 'react';
import { Grid, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import BusinessIcon from '@mui/icons-material/Business';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PersonIcon from '@mui/icons-material/Person';
import WarningIcon from '@mui/icons-material/Warning';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import {
  listCompanies,
  listInsCompanies as getInsuranceCompanies,
  listAgents as getAgents,
  listRiskItems as getRiskItems,
  listBankers as getBankers,
} from '../api';

const CompanyCards = () => {
  const navigate = useNavigate();
  const [companyStats, setCompanyStats] = useState({
    total_companies: 0,
    total_insurance_companies: 0,
    total_agents: 0,
    total_risk_items: 0,
    total_financiers: 0,
  });

  useEffect(() => {
    const fetchCompanyStats = async () => {
      try {
        const [companyDetails, insuranceCompanies, agents, riskItems, bankers] = await Promise.all([
          listCompanies(),
          getInsuranceCompanies(),
          getAgents(),
          getRiskItems(),
          getBankers(),
        ]);

        setCompanyStats({
          total_companies: companyDetails.length,
          total_insurance_companies: insuranceCompanies.length,
          total_agents: agents.length,
          total_risk_items: riskItems.length,
          total_financiers: bankers.length,
        });
      } catch (error) {
        console.error('Failed to fetch company stats:', error.message);
        setCompanyStats({
          total_companies: 0,
          total_insurance_companies: 0,
          total_agents: 0,
          total_risk_items: 0,
          total_financiers: 0,
        });
      }
    };

    fetchCompanyStats();
    const interval = setInterval(fetchCompanyStats, 30000);
    return () => clearInterval(interval);
  }, []);

  const cardData = [
    {
      title: 'Total Companies',
      value: companyStats.total_companies,
      icon: <BusinessIcon fontSize="large" sx={{ color: '#ffffff' }} />,
      tab: 0,
    },
    {
      title: 'Insurance Companies',
      value: companyStats.total_insurance_companies,
      icon: <AccountBalanceIcon fontSize="large" sx={{ color: '#ffffff' }} />,
      tab: 1,
    },
    {
      title: 'Agents',
      value: companyStats.total_agents,
      icon: <PersonIcon fontSize="large" sx={{ color: '#ffffff' }} />,
      tab: 2,
    },
    {
      title: 'Risk Items',
      value: companyStats.total_risk_items,
      icon: <WarningIcon fontSize="large" sx={{ color: '#ffffff' }} />,
      tab: 3,
    },
    {
      title: 'Financiers',
      value: companyStats.total_financiers,
      icon: <MonetizationOnIcon fontSize="large" sx={{ color: '#ffffff' }} />,
      tab: 4,
    },
  ];

  return (
    <>
      {cardData.length > 0 ? (
        cardData.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} lg={2.2} key={index}>
            <CardWithFlip item={item} navigateTo={() => navigate(`/data?tab=${item.tab}`)} />
          </Grid>
        ))
      ) : (
        <Typography sx={{ color: '#ffffff', textAlign: 'center', width: '100%' }}>
          Loading data or no data available
        </Typography>
      )}
    </>
  );
};

const CardWithFlip = ({ item, navigateTo }) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const debounceRef = useRef(null);

  const handleMouseEnter = () => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      setIsFlipped(true);
    }, 100);
  };

  const handleMouseLeave = () => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      setIsFlipped(false);
    }, 100);
  };

  return (
    <Box
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={navigateTo}
      sx={{
        '--sz': 'min(40vh, clamp(80px, 18vw, 290px))', // Reduced size
        width: 'var(--sz)',
        height: 'calc(0.3 * var(--sz))', // Further reduced height
        maxWidth: 'calc(80vw - 15px)',
        perspective: '1200px',
        cursor: 'pointer',
        fontFamily: '"Mona Sans", sans-serif',
        position: 'relative',
        borderRadius: '18px',
      }}
    >
      <Box
        className="card-inner"
        sx={{
          width: '100%',
          height: '100%',
          position: 'relative',
          transformStyle: 'preserve-3d',
          transition: 'transform 0.6s ease-in-out',
          transitionDelay: '0.05s',
          transform: isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)',
        }}
      >
        <Box
          className="card-front"
          sx={{
            position: 'absolute',
            width: '100%',
            height: '120%',
            backfaceVisibility: 'hidden',
            borderRadius: '18px',
            background: 'linear-gradient(135deg, #000000 0%, #ffffff 100%)',
            display: 'flex',
            alignItems: 'center',
            padding: '6px 12px',
            gap: '8px',
            border: '1px solid #ffffff33',
            backgroundImage: `
              linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),
              linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px)
            `,
            backgroundSize: '18px 18px',
          }}
        >
          <Box>{item.icon}</Box>
          <Box>
            <Typography
              variant="h6"
              sx={{
                fontSize: 'calc(2.8 * var(--fz, 0.038 * var(--sz)))',
                fontWeight: 800,
                lineHeight: '116%',
                color: '#ffffff',
                animation: 'textSlide 3s infinite ease-in-out',
                '@keyframes textSlide': {
                  '0%': { transform: 'translateY(0)' },
                  '50%': { transform: 'translateY(-3px)' },
                  '100%': { transform: 'translateY(0)' },
                },
              }}
            >
              {item.value}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontSize: 'calc(1 * var(--fz, 0.038 * var(--sz)))',
                fontWeight: 600,
                lineHeight: '142%',
                color: '#ffffffcc',
                animation: 'textSlide 3s infinite ease-in-out',
                animationDelay: '0.2s',
                '@keyframes textSlide': {
                  '0%': { transform: 'translateY(0)' },
                  '50%': { transform: 'translateY(-3px)' },
                  '100%': { transform: 'translateY(0)' },
                },
              }}
            >
              {item.title}
            </Typography>
          </Box>
        </Box>
        <Box
          className="card-back"
          sx={{
            position: 'absolute',
            width: '100%',
            height: '120%',
            backfaceVisibility: 'hidden',
            borderRadius: '18px',
            background: 'linear-gradient(135deg, #ffffff 0%, #000000 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transform: 'rotateY(180deg)',
            border: '1px solid #ffffff33',
            backgroundImage: `
              linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),
              linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px)
            `,
            backgroundSize: '18px 18px',
          }}
        >
          <Typography
            variant="body1"
            sx={{
              color: '#ffffff',
              fontWeight: 600,
              textAlign: 'center',
              animation: 'textSlide 3s infinite ease-in-out',
              '@keyframes textSlide': {
                '0%': { transform: 'translateY(0)' },
                '50%': { transform: 'translateY(-3px)' },
                '100%': { transform: 'translateY(0)' },
              },
            }}
          >
            View Details
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default CompanyCards;

const globalStyles = `
  @import url("https://fonts.cdnfonts.com/css/mona-sans");
`;
const styleSheet = document.createElement('style');
styleSheet.type = 'text/css';
styleSheet.innerText = globalStyles;
document.head.appendChild(styleSheet);